// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__Shd9A","formItem":"styles_formItem__8NNOd","formFull":"styles_formFull__+nr0g","InputNumber":"styles_InputNumber__Ki7hT"};